import React, { useState, useEffect, useContext } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import "./_steps.scss";

import { GlobalContext } from "./../../../utils/global-context";
import Button from "./../../01-atoms/button/button";
import Loader from "./../../01-atoms/loader/loader";
import { GET_PARAGRAPH_BY_ID } from "./../../../utils/queries";

const Steps = ({ steps }) => {
  const {
    defaultImage,
    setCurrentImage,
    setDefaultImage,
    setImageOpacity,
    setImageTransitionTimer,
    imageTransitionTimer,
    goToStep
  } = useContext(GlobalContext) || {};

  // eslint-disable-next-line no-unused-vars
  const [currentID, setCurrentID] = useState(null);
  const [currentStepState, setCurrentStepState] = useState("loaded");

  // eslint-disable-next-line no-unused-vars
  const [getStep, { loading, data }] = useLazyQuery(GET_PARAGRAPH_BY_ID, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (data?.paragraphById) {
      goToStep(data.paragraphById);
      setCurrentStepState("loaded");
    }
  }, [data, goToStep]);



  return (
    <div className="wizard__steps">
      {steps.map((entity, idx) => {
        const image = entity.fieldImage?.url;
        const icon = entity.fieldIllustration ?? null;
        const text = entity.fieldLabel ?? null;
        const link = entity.fieldLink?.path ?? "";

        const mouseEnterStep = () => {
          if (image && image !== defaultImage) {
            setImageOpacity(0);
            setImageTransitionTimer(
              setTimeout(() => {
                setCurrentImage(image);
                setImageOpacity(1);
              }, 300)
            );
          }
        };

        const mouseLeaveStep = () => {
          if (image && image !== defaultImage) {
            clearTimeout(imageTransitionTimer);
            setImageOpacity(0);
            setTimeout(() => {
              setCurrentImage(null);
              setImageOpacity(1);
            }, 300);
          }
        };

        const clickStep = () => {
          clearTimeout(imageTransitionTimer);
          setDefaultImage(image);

          if (entity.fieldSelectLinkSteps === "steps") {
            setCurrentStepState("loading");

            const optionStepID = entity.fieldWizardSteps?.[0]?.entityId;
            setCurrentID(optionStepID);

            if (optionStepID) getStep({ variables: { id: optionStepID } });
          }
        };

        return currentStepState === "loaded" ? (
          <Button
            key={idx}
            icon={icon}
            text={text}
            href={link}
            mouseEnter={mouseEnterStep}
            mouseLeave={mouseLeaveStep}
            click={clickStep}
          />
        ) : (
          <Loader key={idx} />
        );
      })}
    </div>
  );
};

export default Steps;
